import { useCountDown } from "@/Common/hooks/CountDown/useCountDown";

type CountDownProps = {
	time: number;
	onTimesUp: () => void;
};

export default function CountDown(props: Readonly<CountDownProps>) {
	const { time, onTimesUp } = props;
	const { counter } = useCountDown({ countFrom: time, onTimesUp });
	return <span>{counter}</span>;
}
